import styled from 'styled-components'
import { Button as AntdButton } from 'antd'

const PRIMARY = '#002880'
const BG_LIGHT = '#f2f4f8'
const BORDER = '#e6e9f0'

export const Messages = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	overflow-y: auto;
	padding: 0.5rem 0;
	gap: 0.5rem;
`

export const Message = styled.div`
	display: flex;
	align-items: flex-start;
	padding: 0.5rem;
	gap: 0.75rem;

	img {
		width: 2.25rem;
		height: 2.25rem;
		flex-shrink: 0;
	}
`

export const UserMessage = styled(Message)`
	flex-direction: row-reverse;

	span {
		background: ${PRIMARY};
		color: #fff;
		border-radius: 0.75rem 0.125rem 0.75rem 0.75rem;
		padding: 0.6rem 1rem;
		max-width: 80%;
		word-break: break-word;
		line-height: 1.5;
	}
`

export const AssistantMessage = styled(Message)`
	span {
		background: ${BG_LIGHT};
		color: #1a1a2e;
		border-radius: 0.125rem 0.75rem 0.75rem 0.75rem;
		padding: 0.6rem 1rem;
		max-width: 85%;
		word-break: break-word;
		line-height: 1.6;

		p {
			margin: 0 0 0.4rem 0;
			text-align: justify;
		}

		ul,
		ol {
			margin: 0.25rem 0;
			padding-left: 1.25rem;
		}

		li {
			margin-bottom: 0.2rem;
		}

		strong {
			color: ${PRIMARY};
		}
	}
`

export const InputContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.75rem 0 0 0;
	border-top: 1px solid ${BORDER};
`

export const SendButton = styled(AntdButton)`
	background-color: ${PRIMARY};
	color: #fff;
	border: none;
	height: 2.5rem;
	width: 2.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	border-radius: 0.375rem;

	&:hover,
	&:focus {
		background-color: #003db3 !important;
		color: #fff !important;
	}

	&:disabled {
		background-color: #c0c8dc !important;
		color: #fff !important;
	}
`

export const StartReviewContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;
	gap: 1.25rem;
	padding: 2rem;
	text-align: center;

	h3 {
		color: ${PRIMARY};
		margin: 0;
		font-size: 1.1rem;
	}

	p {
		color: #555;
		margin: 0;
		font-size: 0.9rem;
		line-height: 1.6;
		max-width: 320px;
	}
`

export const StartReviewButton = styled(AntdButton)`
	background-color: ${PRIMARY};
	color: #fff;
	border: none;
	height: 2.75rem;
	padding: 0 2rem;
	font-size: 0.95rem;
	border-radius: 0.375rem;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover,
	&:focus {
		background-color: #003db3 !important;
		color: #fff !important;
	}
`

export const HistoryContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	overflow-y: auto;
	padding: 0.5rem 0;
	gap: 0.75rem;
`

export const HistoryEmpty = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;
	gap: 0.75rem;
	color: #888;
	text-align: center;
	padding: 2rem;

	span {
		font-size: 0.9rem;
	}
`

export const TipCard = styled.div`
	background: ${BG_LIGHT};
	border-left: 3px solid ${PRIMARY};
	border-radius: 0 0.375rem 0.375rem 0;
	padding: 0.75rem 1rem;

	.tip-date {
		font-size: 0.75rem;
		color: #888;
		margin-bottom: 0.4rem;
	}

	.tip-content {
		font-size: 0.875rem;
		color: #1a1a2e;
		line-height: 1.6;

		p {
			margin: 0 0 0.3rem 0;
		}

		ul,
		ol {
			margin: 0.25rem 0;
			padding-left: 1.2rem;
		}

		li {
			margin-bottom: 0.15rem;
		}

		strong {
			color: ${PRIMARY};
		}
	}
`

export const LimitScreen = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;
	gap: 1rem;
	padding: 2rem;
	text-align: center;

	h3 {
		color: #c0392b;
		margin: 0;
		font-size: 1.1rem;
	}

	p {
		color: #555;
		margin: 0;
		font-size: 0.9rem;
		line-height: 1.6;
		max-width: 320px;
	}

	.reset-info {
		background: #fef9e7;
		border: 1px solid #f9ca24;
		border-radius: 0.375rem;
		padding: 0.6rem 1.25rem;
		font-size: 0.85rem;
		color: #7d6608;
	}

	.usage-bar {
		width: 100%;
		max-width: 280px;
		background: #e8ecf4;
		border-radius: 99px;
		height: 8px;
		overflow: hidden;

		div {
			height: 100%;
			background: #c0392b;
			border-radius: 99px;
		}
	}

	.usage-label {
		font-size: 0.8rem;
		color: #888;
	}
`

export const TabBar = styled.div`
	display: flex;
	border-bottom: 2px solid ${BORDER};
	margin-bottom: 0.75rem;
`

export const TabItem = styled.button`
	background: none;
	border: none;
	padding: 0.6rem 1.25rem;
	font-size: 0.9rem;
	cursor: pointer;
	color: ${({ $active }) => ($active ? PRIMARY : '#777')};
	border-bottom: 2px solid ${({ $active }) => ($active ? PRIMARY : 'transparent')};
	margin-bottom: -2px;
	font-weight: ${({ $active }) => ($active ? 600 : 400)};
	transition: all 0.15s;

	&:hover {
		color: ${PRIMARY};
	}
`
